module.exports = {
    admins: [
        '0xcf322b554b6cfb668221d5b1979b6e4e58ab4dbc',
        '0x9dd43969fe08cf5e4558dae6baed08a28eef8a9c',
        '0x53eeff2bbce9aa26bbc3ff3d03831925d9afb259',
        '0x04e823d9c3b4e7cbe1e28081dabad4c0c7e09c82',
        '0x775f8ff47cb858b08fae87bb215c227e073abba1'
    ]
};
